<div class="dialog-container">
  <div class="dialog-description">آیا میخواهید پست خود را حذف کنید؟</div>
  <div class="dialog-button" (click)="remove()">حذف</div>
  <div class="dialog-button" (click)="cancel()">لغو</div>
</div>
